import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { roleMasterActions, userMasterActions } from "../../actions";
import tableRequest from "../../models/tableRequest";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { CatalogueMasterActions } from "../../actions/CatalogueMasterActions";
import { FileUpload } from "primereact/fileupload";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputText } from "primereact/inputtext";

class CatalogueMaster extends Component {
  constructor(props) {
    super(props);
    this.csvLink = React.createRef();
    this.yearSelectRef = React.createRef();
    this.tblResponse = new tableRequest();
    this.state = {
      showDetailsModal: false,
      catalogueDetails: [
        {
          id: 0,
          image: "",
          url: "",
          isActive: true,
          catalogName: "",
        },
      ],
      isDetailsUploading: false,
      isUploading: false,
      GSBPhoto: "",
      GSBPhotoPreview: "",
      editCatalogueId: null,
      isActive: true,
      editMode: false,
      formError: {
        GSBPhoto: "",
      },
      catalogueYear: "",
      showYearDropdown: false,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      sortOrder: "",
      IsAdd: true,
      IsEdit: true,
      showUploadModal: false,
    };

    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.getYearOptions = this.getYearOptions.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
  }

  componentDidMount() {
    this.props.fetchApi(this.tblResponse);
  }

  setHeaderImagePath = (event) => {
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);

      if (response.ResponseCode === "200") {
        this.setState({
          GSBPhoto: response.Source,
          GSBPhotoPreview: response.Source,
          formError: {
            ...this.state.formError,
            GSBPhoto: "",
          },
        });
      } else {
        toast.error(response.ResponseMessage || "Image upload failed");
      }
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.catalogues !== this.props.catalogues) {
      const list = this.props.catalogues || [];
      const total = list.length > 0 ? list[0].TotalRows : 0;

      this.setState({
        totalRecords: total,
        first: total === 0 ? 0 : this.state.first,
      });
    }

    // 🔹 header save
    if (
      prevProps.headerUpserted !== this.props.headerUpserted &&
      this.props.headerUpserted
    ) {
      this.props.fetchApi(this.tblResponse);
      this.resetUploadState();
      this.setState({
        editMode: false,
        editCatalogueId: null,
        first: 0,
      });
    }
    if (
      prevProps.detailsUpserted !== this.props.detailsUpserted &&
      this.props.detailsUpserted
    ) {
      this.props.fetchApi(this.tblResponse);
      this.setState({
        showDetailsModal: false,
        first: 0,
      });
    }
  }

  // AddHeader() {
  //   const { catalogueYear, GSBPhoto, editCatalogueId, isActive, editMode } =
  //     this.state;
  //   if (!catalogueYear) {
  //     toast.error("Please select catalogue year");
  //     return;
  //   }

  //   if (!GSBPhoto) {
  //     toast.error("Please upload header image");
  //     return;
  //   }

  //   const payload = {
  //     Id: editMode ? editCatalogueId : 0,
  //     CatalogueYear: catalogueYear,
  //     HeaderImage: GSBPhoto,
  //     IsActive: editMode ? isActive : true,
  //   };

  //   this.props.upsertHeader(payload);
  // }

  onImageSelect = (e) => {
    const file = e.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        GSBPhotoPreview: reader.result,
        formError: { ...this.state.formError, GSBPhoto: "" },
      });
    };

    reader.readAsDataURL(file);
  };

  onSaveHeader = () => {
    const { catalogueYear, GSBPhoto, editCatalogueId, isActive, editMode } =
      this.state;
    if (!catalogueYear) {
      toast.error("Please select catalogue year");
      return;
    }

    if (!GSBPhoto) {
      toast.error("Please upload header image");
      return;
    }

    const payload = {
      Id: editMode ? editCatalogueId : 0,
      CatalogueYear: catalogueYear,
      HeaderImage: GSBPhoto,
      IsActive: editMode ? isActive : true,
    };

    this.props.upsertHeader(payload);
  };

  getYearOptions = () => {
    const { catalogues } = this.props;
    const { catalogueYear } = this.state;

    const currentYear = new Date().getFullYear();
    const allYears = Array.from({ length: 5 }, (_, i) => currentYear + i);

    const existingYears = new Set(
      (catalogues || []).map((c) => String(c.CatalogueYear)),
    );

    return allYears.filter(
      (year) =>
        !existingYears.has(String(year)) ||
        String(year) === String(catalogueYear),
    );
  };

  validateAllFields = () => {
    const errors = {};
    const state = this.state;
    const isDealer = state.RoleName === "Dealer";

    // Common validations for all roles
    if (!state.UserName) errors.UserName = "Please enter username.";
    if (!state.UserTypeId) errors.UserTypeId = "Please select user type.";
    if (!state.RoleId) errors.RoleId = "Please select user role.";
    if (!state.Email) {
      errors.Email = "Please enter email.";
    } else if (
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(state.Email)
    ) {
      errors.Email = "Please enter valid email.";
    }

    if (!state.DealerMobileNo) {
      errors.DealerMobileNo = "Please enter mobile number.";
    } else if (!/^[6-9]\d{9}$/.test(state.DealerMobileNo)) {
      errors.DealerMobileNo = "Please enter valid mobile number.";
    }

    if (!state.Password || state.Password.length < 4) {
      errors.Password = "Password should be minimum 4 characters long.";
    }

    if (state.Password !== state.ConfirmPassword) {
      errors.ConfirmPassword = "Passwords do not match.";
    }
    // Role-specific validations
    else if (
      [
        "ASM",
        "Customer",
        "Sales Coordinator",
        "Sales Person",
        "Accounts Department",
        "Logistics Department",
      ].includes(state.RoleName)
    ) {
      if (!state.State) errors.State = "Please select state.";
      if (!state.District) errors.District = "Please select district.";
      if (!state.City) errors.City = "Please select city.";
    }

    return errors;
  };

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    //this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    let searchValue = "";
    if (event.globalFilter) {
      searchValue = event.globalFilter;
    } else if (event.filters) {
      const filterValues = Object.values(event.filters)
        .map((f) => f?.value)
        .filter((v) => v);
      searchValue = filterValues.join(" ");
    }
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  onPage(event) {
    this.props.loadingData(true);
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0]?.field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0]?.field || "";
    this.tblResponse.SortColumn = sortField;
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.props.fetchApi(this.tblResponse);
  }
  handleDetailChange = (e, index) => {
    const { name, value, checked, type } = e.target;
    const list = [...this.state.catalogueDetails];

    list[index][name] = type === "checkbox" ? checked : value;
    this.setState({ catalogueDetails: list });
  };
  handleRemoveClick = (index) => {
    const list = [...this.state.catalogueDetails];
    list.splice(index, 1);
    this.setState({ catalogueDetails: list });
  };

  saveCatalogueDetails = () => {
    const { editCatalogueId, catalogueDetails } = this.state;

    if (!catalogueDetails || catalogueDetails.length === 0) {
      toast.error("Please add at least one catalogue detail");
      return;
    }
    for (let i = 0; i < catalogueDetails.length; i++) {
      const item = catalogueDetails[i];

      if (!item.image || !item.url || !item.catalogName) {
        toast.error("Please fill all catalogue details");
        return;
      }
    }
    const payload = {
      headerId: editCatalogueId,
      userId: 0,
      items: catalogueDetails.map((x) => ({
        id: x.id,
        image: x.image,
        url: x.url,
        isActive: x.isActive,
        catalogName: x.catalogName,
      })),
    };

    this.props.upsertDetails(payload);
  };

  photoBodyTemplate(e) {
    if (e.HeaderImage) {
      return <img src={e.HeaderImage} width="50px" height="50px" />;
    }
  }
  actionBodyTemplate(rowData) {
    if (rowData && this.state.IsEdit) {
      return (
        <div className="d-flex justify-content-center gap-2">
          {/* Add Catalogue Details */}
          <Button
            icon="pi pi-plus"
            className=" p-button-sm"
            style={{ backgroundColor: "#1e88e5" }}
            tooltip="Add Catalogue Details"
            tooltipOptions={{ position: "top" }}
            onClick={() => {
              this.setState({
                showDetailsModal: true,
                editCatalogueId: rowData.Id,
                catalogueDetails: (rowData.CatalogueDetails || []).map((x) => ({
                  id: x.Id || 0,
                  image: x.Image || "",
                  url: x.URL || "",
                  isActive: x.IsActive ?? true,
                  catalogName: x.CatalogName || "",
                })),
              });
            }}
          />

          {/* Edit Header Image */}
          <Button
            icon="pi pi-pencil"
            className="p-button-sm"
            style={{ backgroundColor: "#fb8c00" }}
            tooltip="Edit Header Image"
            tooltipOptions={{ position: "top" }}
            onClick={() => {
              this.setState({
                editMode: true,
                editCatalogueId: rowData.Id,
                isActive: rowData.IsActive,
                catalogueYear: rowData.CatalogueYear,
                GSBPhoto: rowData.HeaderImage,
                GSBPhotoPreview: rowData.HeaderImage,
                showUploadModal: true,
              });
            }}
          />
        </div>
      );
    }

    return null;
  }

  resetUploadState = () => {
    if (this.headerUploader) {
      try {
        this.headerUploader.clear();
      } catch (e) {}
    }

    this.setState({
      showUploadModal: false,
      isUploading: false,
      GSBPhoto: "",
      GSBPhotoPreview: "",
      catalogueYear: "",
      showYearDropdown: false,
      formError: { GSBPhoto: "" },
    });
  };

  uploadDocument = async ({ files }, index) => {
    try {
      const file = files[0];
      if (!file) return;
      this.setState({ isDetailsUploading: true });
      const formData = new FormData();
      formData.append("document", file);

      const res = await fetch(
        process.env.REACT_APP_API_URL + "UploadFile/DocumentUpload",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();

      if (data.ResponseCode === "200") {
        this.setState((prev) => {
          const catalogueDetails = [...prev.catalogueDetails];
          catalogueDetails[index].url = data.Source;
          return { catalogueDetails };
        });
      } else {
        toast.error(data.ResponseMessage || "Document upload failed");
      }
    } catch (err) {
      toast.error("Upload error");
    } finally {
      this.setState({ isDetailsUploading: false });
    }
  };

  uploadHeaderImage = async ({ files }, { type, index = null }) => {
    try {
      const file = files[0];
      if (!file) return;
      if (type === "detail" && index !== null) {
        this.setState({ isDetailsUploading: true });
      }
      if (type === "header") {
        this.setState({ isUploading: true });
      }
      const formData = new FormData();
      formData.append("headerImage", file);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}UploadFile/ImageUpload`,
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await res.json();

      if (data.ResponseCode === "200") {
        if (type == "header") {
          this.setState({
            GSBPhoto: data.Source,
            GSBPhotoPreview: data.Source,
            isUploading: false,
            formError: { GSBPhoto: "" },
          });
          this.headerUploader.clear();
        }
        if (type === "detail" && index !== null) {
          const list = [...this.state.catalogueDetails];
          list[index].image = data.Source;
          this.setState({ catalogueDetails: list });
        }
      }
      else {
        toast.error(data.ResponseMessage || "Upload failed");
      }
    } catch (err) {
      // toast.error("Upload error");
    } finally {
      this.setState({ isDetailsUploading: false });
      this.setState({ isUploading: false });
    }
  };

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }
  handleAddClick = () => {
    this.setState((prev) => ({
      catalogueDetails: [
        ...prev.catalogueDetails,
        {
          id: 0,
          image: "",
          url: "",
          isActive: true,
          catalogName: "",
        },
      ],
    }));
  };

  render() {
    const header = (
      <div className="table-header row">
        <div className="col-md-6">
          <h4 className="user">Catalogue Master</h4>
        </div>
        <div className="col-md-6 d-flex justify-content-end">
          <span className="search d-flex align-items-center">
            <i className="p-input-icon-left mr-2" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>

          <Button
            style={{ marginLeft: "10px" }}
            className="mr-2"
            icon="pi pi-plus"
            label="Add"
            onClick={() => {
              this.setState({ showUploadModal: true });
              this.setState({ editMode: false });
            }}
          />
        </div>
      </div>
    );

    return (
      <div className="datatable-filter-demo">
        <ToastContainer />
        <div className="table-header row">
          {/* <div className="col-md-6">
            <h5 className="main-head">Catalogue Master</h5>
          </div> */}

          {/* <div className="col-md-6 d-flex justify-content-end">
            <div className="search d-flex align-items-center">
              <span className="p-input-icon-left mr-2">
                <i className="pi pi-search" />
                <InputText
                  type="search"
                  onInput={(e) => this.searchFilter(e)}
                  placeholder="Global Search"
                />
              </span>
              {this.state.IsAdd && (
                <Button
                  style={{ marginLeft: "10px" }}
                  label="Add User"
                  icon="pi pi-plus-circle"
                  onClick={this.openDialog}
                />
              )}
            </div>
          </div> */}
        </div>

        <Dialog
          header={
            this.state.editMode ? "Edit Header Image" : "Upload Header Image"
          }
          modal
          dismissableMask={false}
          style={{ maxWidth: "500px" }}
          visible={this.state.showUploadModal}
          className="popup1"
          onHide={this.resetUploadState}
        >
          <div
            style={{
              backgroundColor: "#fff",
            }}
            className="p-3 position-relative"
          >
            {this.state.isDetailsUploading && (
              <div
                className="position-absolute top-0 start-0 w-100 h-100
                   d-flex align-items-center justify-content-center"
                style={{
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 1000,
                }}
              >
                <div className="d-flex flex-column text-center">
                  <ProgressSpinner
                    style={{ width: "50px", height: "50px" }}
                    strokeWidth="4"
                  />
                  <small className="mt-2">Uploading ...</small>
                </div>
              </div>
            )}
            <div className="year-input-group my-4">
              <input
                type="text"
                readOnly
                placeholder="Select Year"
                value={this.state.catalogueYear}
                className="year-input p-inputtext p-component"
                disabled={this.state.editMode}
                onClick={() =>
                  this.setState({
                    showYearDropdown: !this.state.showYearDropdown,
                  })
                }
              />

              <div
                className="year-icon-box"
                onClick={() =>
                  this.setState({
                    showYearDropdown: !this.state.showYearDropdown,
                  })
                }
              >
                <i className="fa fa-calendar"></i>
              </div>

              {this.state.showYearDropdown && (
                <ul className="year-dropdown">
                  {this.getYearOptions().map((year) => (
                    <li
                      key={year}
                      onClick={() =>
                        this.setState({
                          catalogueYear: year,
                          showYearDropdown: false,
                        })
                      }
                    >
                      {year}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {/* Upload Box */}
            <div
              className="upload-box"
              onClick={() => this.headerUploader.choose()}
            >
              {this.state.GSBPhotoPreview ? (
                <img
                  src={this.state.GSBPhotoPreview}
                  alt="Header Preview"
                  className="upload-preview"
                />
              ) : (
                <div className="upload-placeholder">
                  <i className="fa fa-cloud-upload upload-icon" />
                  <p>Click to upload header image</p>
                  <span>PNG / JPG / JPEG (Max 2MB)</span>
                </div>
              )}
            </div>

            <FileUpload
              ref={(el) => (this.headerUploader = el)}
              name="headerImage"
              mode="basic"
              customUpload
              uploadHandler={(e) =>
                this.uploadHeaderImage(e, { type: "header" })
              }
              accept="image/png,image/jpeg,image/jpg"
              maxFileSize={2000000}
              onSelect={(e) => {
                this.onImageSelect(e);
                this.headerUploader.upload();
              }}
              className="hidden-fileupload"
            />

            {/* Error */}
            {this.state.formError.GSBPhoto && (
              <div className="error mt-2">{this.state.formError.GSBPhoto}</div>
            )}

            {this.state.editMode && (
              <div className="form-check mt-2 d-flex justify-content-center gap-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isActiveCheckbox"
                  checked={this.state.isActive}
                  onChange={(e) => {
                    this.setState({ isActive: e.target.checked });
                  }}
                />
                <label
                  className="form-check-label ml-1"
                  htmlFor="isActiveCheckbox"
                >
                  Active
                </label>
              </div>
            )}

            {/* Footer */}
            <div className="d-flex justify-content-end mt-4 gap-2">
              <button
                className="btn btn-secondary"
                onClick={this.resetUploadState}
              >
                Cancel
              </button>

              <button className="btn btn-primary" onClick={this.onSaveHeader}>
                Save
              </button>
            </div>
          </div>
        </Dialog>

        <div className="card">
          <DataTable
            value={this.props.catalogues}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={this.state.totalRecords || 0}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="CatalogueYear"
              headerStyle={{ width: "120px" }}
              bodyStyle={{}}
              header="Year"
         
            />
            <Column
              field="HeaderImage"
              headerStyle={{ width: "200px" }}
              header="Header Image"
              body={this.photoBodyTemplate}
            />

            {this.state.IsEdit && (
              <Column
                field="Action"
                header="Action"
                headerStyle={{ width: "120px" }}
                bodyStyle={{ width: "120px" }}
                body={this.actionBodyTemplate}
                className="text-center"
              />
            )}
          </DataTable>
          <Dialog
            header="Add Catalogue Details"
            modal
            dismissableMask={false}
            visible={this.state.showDetailsModal}
            className="popup1"
            onHide={() => this.setState({ showDetailsModal: false })}
          >
            <div
              style={{
                backgroundColor: "#fff",
              }}
              className="p-3 position-relative"
            >
              {this.state.isDetailsUploading && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100
                   d-flex align-items-center justify-content-center"
                  style={{
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 1000,
                  }}
                >
                  <div className="d-flex flex-column text-center">
                    <ProgressSpinner
                      style={{ width: "50px", height: "50px" }}
                      strokeWidth="4"
                    />
                    <small className="mt-2">Uploading ...</small>
                  </div>
                </div>
              )}
              <div
                style={{
                  pointerEvents: this.state.isDetailsUploading
                    ? "none"
                    : "auto",
                  opacity: this.state.isDetailsUploading ? 0.6 : 1,
                }}
              >
                <div className="col-md-12 text-right mb-3">
                  <Button
                    onClick={this.handleAddClick}
                    label="Add"
                    icon="pi pi-plus"
                  />
                </div>

                {this.state.catalogueDetails.map((item, index) => (
                  <div className="row align-items-start mb-3" key={index}>
                    <div className="col-md-2 col-sm-12">
                      <label>Catalog Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="catalogName"
                        placeholder="Enter catalog name"
                        value={item.catalogName}
                        onChange={(e) => this.handleDetailChange(e, index)}
                      />
                    </div>

                    <div className="col-md-3 col-sm-12">
                      <label>Image</label>

                      <FileUpload
                        ref={(el) => (this[`detailUploader_${index}`] = el)}
                        mode="basic"
                        customUpload
                        auto
                        accept="image/png,image/jpeg,image/jpg"
                        maxFileSize={2000000}
                        uploadHandler={(e) =>
                          this.uploadHeaderImage(e, { type: "detail", index })
                        }
                      />
                      {item.image && (
                        <div className="mt-2">
                          <img
                            src={item.image}
                            alt="Preview"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {/* URL */}
                    <div className="col-md-5 col-sm-12">
                      <label>Document</label>

                      <FileUpload
                        mode="basic"
                        customUpload
                        auto
                        accept="application/pdf"
                        maxFileSize={20 * 1024 * 1024}
                        uploadHandler={(e) => this.uploadDocument(e, index)}
                        onValidationFail={() =>
                          toast.error("File size should be less than 20 MB")
                        }
                      />
                      {item.url && (
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Upload document"
                          style={{ maxWidth: "250px" }}
                          value={item.url ? item.url.split("/").pop() : ""}
                          disabled
                        />
                      )}
                    </div>

                    {/* Active */}
                    <div className="col-md-2 col-sm-6 ">
                      <div className="form-check mt-4">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="isActive"
                          checked={item.isActive}
                          onChange={(e) => this.handleDetailChange(e, index)}
                        />
                        <label className="form-check-label ml-1">Active</label>
                      </div>
                    </div>

                    {/* Remove */}
                    <div
                      className="col-md-2 col-sm-6 d-flex"
                      style={{ marginLeft: "auto" }}
                    >
                      {this.state.catalogueDetails.length > 1 && (
                        <Button
                          icon="pi pi-times"
                          className="p-button-rounded p-button-danger p-button-text mt-3 "
                          onClick={() => this.handleRemoveClick(index)}
                        />
                      )}
                    </div>
                  </div>
                ))}

                <div className="d-flex justify-content-center mt-4 gap-2">
                  <Button
                    label="Cancel"
                    className="p-button-secondary"
                    onClick={() => this.setState({ showDetailsModal: false })}
                  />
                  <Button
                    label="Save"
                    className="p-button-primary"
                    onClick={this.saveCatalogueDetails}
                  />
                </div>
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    catalogues: state.catalogueMaster.items,
    loading: state.catalogueMaster.loading,
    headerUpserted: state.catalogueMaster.headerUpserted,
    detailsUpserted: state.catalogueMaster.detailsUpserted,
    error: state.catalogueMaster.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => dispatch(CatalogueMasterActions.getAll(obj)),
    upsertHeader: (payload) =>
      dispatch(CatalogueMasterActions.upsertHeader(payload)),
    upsertDetails: (payload) =>
      dispatch(CatalogueMasterActions.upsertDetails(payload)),
    loadingData: (isLoding) =>
      dispatch(CatalogueMasterActions.loadingData(isLoding)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogueMaster);
